import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {RequestTransport} from "../Model/Model";
import {GetAllDistributionCenter} from "../../../../reduxToolkit/DistributionCenter/DistributionCenterApi";
import {
    GetAllServiceType,
} from "../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {GetEmployeeProviderLists} from "../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {toast} from "react-toastify";
import {
    CreateLogisticRequest, GetAllLogisticRequestById,
    UpdateLogisticRequest
} from "../../../../reduxToolkit/Logistics/logisticRequestSectionApi";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import routes from "../../../../Routes/routes";
import {errorMsg} from "../../../../Apis/functions";
import HandleChange from "../../../../Helpers/HandleChange";
import {permissionObj} from "../../../../Helpers/permission";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const CreateUpdateRequestApp =()=>{
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { id } = useParams();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [getAllDistributionCenter, setGetAllDistributionCenter] = useState([])
    const [getAllServiceType, setGetAllServiceType] = useState([])
    const [getAllSupplier, setGetAllSupplier] = useState([]);
    const [data, setData] = useState({...RequestTransport});
    const [dataLoaded, setDataLoaded] = useState(false)
    // The request is opened as read only from the details route or without the matching permission
    const isDetails = location?.pathname?.includes(routes.transportRequest.details);
    const disabled = isDetails || !(DEV || permission?.includes(
        id ? permissionObj?.WEB_LOGISTIC_REQUEST_UPDATE : permissionObj?.WEB_LOGISTIC_REQUEST_CREATE
    ));
    const [emptyFields, setEmptyFields] = useState(false)
    const { handleChange } = HandleChange({ model: data, setModel: setData });
    const [isValidDeliveryAt, setIsValidDeliveryAt] = useState(true);

    useEffect(() => {
        if(data.departureAt && data.deliveryAt)
            if(data.deliveryAt > data.departureAt) setIsValidDeliveryAt(true);
            else setIsValidDeliveryAt(false);
    }, [data.departureAt, data.deliveryAt]);

    useEffect(()=>{
        dispatch(GetAllDistributionCenter()).then(({payload:{data:{data}}})=>{
            setGetAllDistributionCenter(data)
        });
        dispatch(GetAllServiceType()).then(({payload:{data:{data}}})=>{
            setGetAllServiceType(data)
        });
        dispatch(GetEmployeeProviderLists()).then(({payload: {data: { data }}}) => {
                setGetAllSupplier(data);
            },
        );
    },[dispatch])

    useEffect(() => {
        if(id){
            getData();
        }
    }, [id]);

    const getData = () => {
        dispatch(GetAllLogisticRequestById(id)).then(({payload:{data:{data,success}}})=>{
            if(success){
                setData(RequestTransport.set(data));
                setEmptyFields(false);
                setDataLoaded(true);
            }
        })
    }

    const handleClear = () => {
        setData({...data.clear()});
    };

    const handleCreate = () => {
        if (!data.isValid() || !isValidDeliveryAt) {
            setEmptyFields(true);
            return;
        }

        const payload = id
            ? { id: id, statusId: data.status.id, ...data.toRegister()}
            : data.toRegister();

        const action = id
            ? UpdateLogisticRequest(payload)
            : CreateLogisticRequest(payload);

        dispatch(action).then(({payload:{data:{success, code}}}) => {
            if(success){
                if (id) {
                    getData();
                    toast.success(t('has_been_updated_successfully'));
                } else {
                    toast.success(t('has_been_created_successfully'));
                    navigate(routes.transportRequest.list)
                }
                setEmptyFields(false);
            }else {
                errorMsg(code);
            }
        })
    };
    return {
        DEV,
        permission,
        handleCreate,
        handleClear,
        handleChange,
        data,
        emptyFields,
        getAllDistributionCenter,
        disabled,
        dataLoaded,
        isDetails,
        getAllServiceType,
        getAllSupplier,
        id,
        isValidDeliveryAt
    }
}
